class CartDrawerRecommendations extends HTMLElement {
  connectedCallback() {
    this.#showRandomSubset();
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #showRandomSubset() {
    const showCount = Number(this.dataset.showCount) || 4;
    const items = Array.from(this.querySelectorAll('.cart-drawer-recommendations__item'));

    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.forEach((item, index) => {
      item.hidden = index >= showCount;
    });

    if (items.length && items.every((item) => item.hidden)) {
      this.hidden = true;
    }
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-add-to-cart]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    this.#addToCart(button);
  };

  /** @param {HTMLButtonElement} button */
  async #addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => null);
        throw new Error(error?.message || 'Could not add product to cart');
      }

      await this.#refreshCartDrawer();
      button.textContent = 'Added';
    } catch (error) {
      console.warn('[cart-drawer-recommendations] Add to cart failed:', error);
      button.textContent = 'Error';
    } finally {
      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalLabel;
      }, 1500);
    }
  }

  async #refreshCartDrawer() {
    const root = window.Shopify?.routes?.root ?? '/';
    const response = await fetch(`${root}?sections=cart-drawer-section`);
    if (!response.ok) return;

    const data = await response.json();
    const html = data['cart-drawer-section'];
    if (!html) {
      console.warn('[cart-drawer-recommendations] "cart-drawer-section" key not found in response:', data);
      return;
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const freshInner = parsed.querySelector('[data-hydration-key="cart-drawer-inner"]');
    const currentInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');

    if (freshInner && currentInner) {
      currentInner.outerHTML = freshInner.outerHTML;
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { source: 'cart-drawer-recommendations' },
      })
    );

    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) {
      drawer.open();
    }
  }
}

if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}